const loadingLabel = "Cargando";
const esCO = {
  loadingLabel
};
export {
  esCO as default,
  loadingLabel
};
